"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4547,1937],{

/***/ 71937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M11 1.333h-1v-1a.333.333 0 0 0-.667 0v1H2.667v-1a.333.333 0 0 0-.667 0v1H1a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2.333a1 1 0 0 0-1-1ZM1 2h1v1a.333.333 0 1 0 .667 0V2h6.666v1A.333.333 0 1 0 10 3V2h1a.333.333 0 0 1 .333.333v2.334H.667V2.333A.333.333 0 0 1 1 2Zm10 9.333H1A.333.333 0 0 1 .667 11V5.333h10.666V11a.333.333 0 0 1-.333.333Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCalendar);

/***/ }),

/***/ 60652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RQ": function() { return /* binding */ VARIANT_MAPS; },
/* harmony export */   "r4": function() { return /* binding */ SectionText; }
/* harmony export */ });
/* unused harmony export VARIANT_MAPS_TITLE */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77215);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23097);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89136);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62123);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38959);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94557);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97932);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60864);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81246);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64903);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        flex gap-8 md:mb-6 md:gap-16\n        ",
        "\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            max-w-[802px] justify-between\n            ",
        "\n            ",
        "   \n          "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n              text-heading text-heading-mobile--h2 !font-normal md:text-heading--h2 \n              ",
        "\n              ",
        "\n            "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            flex max-w-[802px]  flex-col gap-4\n            ",
        "\n            ",
        "\n            ",
        " \n           \n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                  mb-5  break-keep !text-[20px]  !font-light  leading-[28px] md:mb-6\n                  ",
        "\n                  ",
        "\n                  ",
        "\n                "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var TEXT_ALIGN_MAPS = {
    center: "flex md:justify-center md:text-center",
    end: "flex md:justify-end md:text-end",
    start: "flex md:justify-start md:text-start"
};
var TEXT_ALIGN_MAPS_MOBILE = {
    center: "flex justify-center text-center",
    end: "flex justify-end text-end",
    start: "flex justify-start text-start"
};
var VARIANT_MAPS = {
    primary: "text-primary-400",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var VARIANT_MAPS_TITLE = {
    primary: "!text-brownie-500",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var SectionText = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, caption = param.caption, desc = param.desc, direction = param.direction, textAlign = param.textAlign, textAlignMobile = param.textAlignMobile, title = param.title, caracteristics = param.caracteristics, variant = param.variant, _caracCols = param.caracCols, caracCols = _caracCols === void 0 ? 2 : _caracCols, directionMobile = param.directionMobile, _showSeeMore = param.showSeeMore, showSeeMore = _showSeeMore === void 0 ? false : _showSeeMore, subtitle = param.subtitle;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var rowCarac = direction === "row" && directionMobile === "row" && !caracteristics;
    var captionAlignment = direction === "column" ? textAlign === "center" ? "md:justify-center md:items-center" : textAlign === "end" ? "md:justify-end md:items-end" : "md:justify-start md:items-start" : "";
    var MobileAlignment = direction === "column" ? textAlignMobile === "center" ? "justify-center items-center" : textAlignMobile === "end" ? "justify-end items-end" : "justify-start items-start" : "";
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ var labels = t("components.atoms.seeMore.labels", "common", {
        returnObjects: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject(), rowCarac ? "flex-row" : "\n              ".concat(directionMobile === "row" ? "flex-row " : "flex-col", "  \n              ").concat(direction === "row" ? "justify-between md:flex-row " : "md:flex-col", "\n            "), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: rowCarac ? "w-full max-w-fit md:w-full" : direction === "row" ? "w-full max-w-fit md:w-1/2" : "",
                children: [
                    caption && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        align: textAlign,
                        className: "mb-4 ".concat(captionAlignment, " ").concat(MobileAlignment),
                        mobileAlignment: textAlignMobile !== null && textAlignMobile !== void 0 ? textAlignMobile : textAlign,
                        variant: variant,
                        children: caption
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject1(), TEXT_ALIGN_MAPS[textAlign], TEXT_ALIGN_MAPS_MOBILE[textAlignMobile !== null && textAlignMobile !== void 0 ? textAlignMobile : textAlign]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                            className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject2(), VARIANT_MAPS_TITLE[variant], !caracteristics ? "w-full" : "sm:w-1/2"),
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        })
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                            className: "text-heading text-heading--h5 ".concat(VARIANT_MAPS[variant]),
                            children: subtitle
                        })
                    })
                ]
            }),
            desc || caracteristics ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject3(), showSeeMore ? "sm:flex-col" : "sm:flex-row", rowCarac ? "w-full md:w-1/2" : "", direction === "row" && !caracteristics ? "w-full md:w-1/2" : ""),
                children: [
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        condition: showSeeMore,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                heigthPx: 150,
                                expanded: false,
                                labels: {
                                    viewLess: labels.viewLess,
                                    viewMore: labels.viewMore
                                },
                                children: children
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            html: desc,
                            className: (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject4(), !caracteristics ? "w-full" : "w-full md:w-1/2", VARIANT_MAPS[variant], TEXT_ALIGN_MAPS[textAlign])
                        })
                    }),
                    caracteristics ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: 'sm:before:content-[" "] flex w-full flex-row sm:w-1/2 sm:before:mr-5 sm:before:block sm:before:h-auto sm:before:w-px sm:before:border-l sm:before:border-primary-400 ',
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            className: "w-full !gap-3 text-primary-400 ",
                            xs: caracCols,
                            md: caracCols,
                            lg: caracCols,
                            children: caracteristics.map(function(child, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item, {
                                    className: "flex flex-row gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            src: child.icon,
                                            width: 20,
                                            height: 20
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "text-body text-body--secondary",
                                            children: child.text
                                        })
                                    ]
                                }, index);
                            })
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
SectionText.displayName = "SectionText";


/***/ }),

/***/ 67526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _SectionText__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60652);

/* harmony default export */ __webpack_exports__["Z"] = (_SectionText__WEBPACK_IMPORTED_MODULE_0__/* .SectionText */ .r4);


/***/ }),

/***/ 97932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ see_more; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/icon/index.ts + 2 modules
var atoms_icon = __webpack_require__(64903);
// EXTERNAL MODULE: ./lib/utils/utils.tsx
var utils = __webpack_require__(52994);
;// CONCATENATED MODULE: ./components/atoms/see-more/SeeMore.tsx






/**
 * SeeMore
 */ var SeeMore = function(param) {
    var children = param.children, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, labels = param.labels, heigthPx = param.heigthPx, numberOfElements = param.numberOfElements, icon = param.icon, className = param.className, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel;
    var ref = (0,react.useState)(expanded), isExpanded = ref[0], setExpanded = ref[1];
    var t = (0,useTranslation/* default */.Z)("common").t;
    var toggle = function(state) {
        setExpanded(state);
    };
    var firstChild = (0,utils/* toArray */.qo)(children)[0];
    var firstChildRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(expanded), seeMore = ref1[0], setSeeMore = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ setSeeMore((firstChildRef === null || firstChildRef === void 0 ? void 0 : (ref = firstChildRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > heigthPx);
    }, [
        firstChildRef,
        heigthPx
    ]);
    (0,react.useEffect)(function() {
        var ref;
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ setSeeMore((firstChildRef === null || firstChildRef === void 0 ? void 0 : (ref = firstChildRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) > heigthPx);
    }, [
        heigthPx
    ]);
    if (!labels) {
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */ /* @ts-ignore */ labels = t("components.atoms.seeMore.labels", "common", {
            returnObjects: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            numberOfElements ? (0,utils/* toArray */.qo)(children).map(function(child, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(index < numberOfElements ? "h-full min-h-full min-w-full opacity-100" : isExpanded ? "h-full min-h-full min-w-full opacity-100" : "h-0 opacity-0 ", " col-span-2 transition-all duration-500 md:col-span-1"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(child.type, (0,_object_spread/* default */.Z)({}, child.props, typeof child.type === "function" ? {
                        seen: index < numberOfElements ? true : isExpanded ? true : false
                    } : {}))
                }, index);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-full transform overflow-hidden transition-all duration-500 ".concat(isExpanded ? "max-h-[1000px]" : "".concat(seeMore ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[35px] after:bg-gradient-to-t after:from-white after:to-[rgba(248,247,246,0.3)] after:content-['']" : "")),
                style: {
                    maxHeight: !isExpanded ? "".concat(heigthPx, "px") : "1000px"
                },
                children: firstChild && /*#__PURE__*/ react.cloneElement(firstChild, {
                    ref: firstChildRef
                })
            }),
            (children === null || children === void 0 ? void 0 : children.length) > numberOfElements || seeMore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-10 col-start-1 col-end-[-1] mt-2 flex ".concat(!hideLabel && "w-full", " cursor-pointer flex-row items-center justify-center gap-2 ").concat(className),
                onClick: function() {
                    return toggle(!isExpanded);
                },
                children: [
                    !hideLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                        as: "span",
                        variant: variant,
                        arrow: false,
                        children: isExpanded ? labels === null || labels === void 0 ? void 0 : labels.viewLess : labels === null || labels === void 0 ? void 0 : labels.viewMore
                    }),
                    icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "transform transition-all duration-500 ".concat(isExpanded ? "rotate-180" : "rotate-0", "\n            "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_icon/* default */.Z, {
                            height: 10,
                            width: 10,
                            src: icon
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
SeeMore.displayName = "SeeMore";

;// CONCATENATED MODULE: ./components/atoms/see-more/index.ts

/* harmony default export */ var see_more = (SeeMore);


/***/ }),

/***/ 10650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ card_blog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(89136);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/molecules/card/index.ts + 1 modules
var card = __webpack_require__(25649);
// EXTERNAL MODULE: ./public/assets/icons/Calendar.svg
var Calendar = __webpack_require__(71937);
;// CONCATENATED MODULE: ./components/molecules/card-blog/CardBlog.tsx









/**
 * CardBlog
 */ var CardBlog = function(_param) {
    var date = _param.date, image = _param.image, slug = _param.slug, title = _param.title, description = _param.description, props = (0,_object_without_properties/* default */.Z)(_param, [
        "date",
        "image",
        "slug",
        "title",
        "description"
    ]);
    var ref = (0,useTranslation/* default */.Z)("common"), t = ref.t, lang = ref.lang;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        multimediaProps: {
            image: image,
            heigth: 200
        },
        backgroundColor: "surface-00"
    }, props), {
        classNames: {
            content: "flex flex-col gap-5 text-text-primary"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-subtitle text-subtitle--large",
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-thin",
                dangerouslySetInnerHTML: {
                    __html: description
                }
            }),
            (date || slug) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-auto flex flex-wrap justify-between gap-4",
                children: [
                    date && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row items-center gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar["default"], {
                                width: 20,
                                height: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-thin",
                                children: new Intl.DateTimeFormat(lang).format(new Date(date))
                            })
                        ]
                    }),
                    slug && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: slug,
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                            arrow: false,
                            underline: true,
                            variant: "primary",
                            children: t("components.organisms.blog.readMore")
                        })
                    })
                ]
            })
        ]
    }));
};
CardBlog.displayName = "CardBlog";

;// CONCATENATED MODULE: ./components/molecules/card-blog/index.ts

/* harmony default export */ var card_blog = (CardBlog);


/***/ }),

/***/ 64547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cards_blog_template; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(77215);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(60123);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(62123);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/molecules/card-blog/index.ts + 1 modules
var card_blog = __webpack_require__(10650);
// EXTERNAL MODULE: ./components/atoms/grid/index.ts + 2 modules
var grid = __webpack_require__(81246);
;// CONCATENATED MODULE: ./components/organisms/blog/Blog.tsx




/**
 * Blog
 */ var Blog = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, cardBelow = param.cardBelow, cardAbove = param.cardAbove, cardLeft = param.cardLeft;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(grid/* default */.Z, {
        className: "!gap-12 md:!gap-8 ".concat(className),
        lg: 2,
        children: [
            Object.keys(cardLeft !== null && cardLeft !== void 0 ? cardLeft : {}).length > 0 && cardLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                rowSpanXS: 2,
                className: "flex items-start justify-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_blog/* default */.Z, (0,_object_spread/* default */.Z)({
                    date: cardLeft.date,
                    image: cardLeft.image,
                    slug: cardLeft.slug,
                    title: cardLeft.title
                }, (cardLeft === null || cardLeft === void 0 ? void 0 : cardLeft.description) && {
                    description: cardLeft === null || cardLeft === void 0 ? void 0 : cardLeft.description
                }))
            }),
            Object.keys(cardAbove !== null && cardAbove !== void 0 ? cardAbove : {}).length > 0 && cardAbove && /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_blog/* default */.Z, (0,_object_spread/* default */.Z)({
                    date: cardAbove.date,
                    image: cardAbove.image,
                    slug: cardAbove.slug,
                    title: cardAbove.title
                }, (cardAbove === null || cardAbove === void 0 ? void 0 : cardAbove.description) && {
                    description: cardAbove === null || cardAbove === void 0 ? void 0 : cardAbove.description
                }))
            }),
            Object.keys(cardBelow !== null && cardBelow !== void 0 ? cardBelow : {}).length > 0 && cardBelow && /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Item */.Z.Item, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_blog/* default */.Z, (0,_object_spread/* default */.Z)({
                    date: cardBelow.date,
                    image: cardBelow.image,
                    slug: cardBelow.slug,
                    title: cardBelow.title
                }, (cardBelow === null || cardBelow === void 0 ? void 0 : cardBelow.description) && {
                    description: cardBelow === null || cardBelow === void 0 ? void 0 : cardBelow.description
                }))
            })
        ]
    });
};
Blog.displayName = "Blog";

;// CONCATENATED MODULE: ./components/organisms/blog/index.ts

/* harmony default export */ var blog = (Blog);

;// CONCATENATED MODULE: ./components/templates/cards-blog-template/CardsBlogTemplate.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          flex flex-col gap-14\n          ",
        "\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var SwiperCustom = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4904), __webpack_require__.e(6306)]).then(__webpack_require__.bind(__webpack_require__, 6306));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6306)
            ];
        }
    }
});
/**
 * CardsBlogTemplate
 */ var CardsBlogTemplate = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, backgroundColorBottom = param.backgroundColorBottom, backgroundColorBottomMobile = param.backgroundColorBottomMobile, backgroundColorTop = param.backgroundColorTop, backgroundColorTopMobile = param.backgroundColorTopMobile, caption = param.caption, _cutLevel = param.cutLevel, cutLevel = _cutLevel === void 0 ? 50 : _cutLevel, _cutLevelMobile = param.cutLevelMobile, cutLevelMobile = _cutLevelMobile === void 0 ? 50 : _cutLevelMobile, desc = param.desc, textColor = param.textColor, title = param.title, blogProps = param.blogProps, link = param.link, _isCarrousel = param.isCarrousel, isCarrousel = _isCarrousel === void 0 ? false : _isCarrousel, _isMobileCarrousel = param.isMobileCarrousel, isMobileCarrousel = _isMobileCarrousel === void 0 ? false : _isMobileCarrousel, id = param.id;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(container/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        backgroundColorBottom: backgroundColorBottom,
        backgroundColorTopMobile: backgroundColorTopMobile,
        backgroundColorTop: backgroundColorTop,
        backgroundColorBottomMobile: backgroundColorBottomMobile,
        cutLevel: cutLevel === null ? 50 : cutLevel,
        cutLevelMobile: cutLevelMobile === null ? 50 : cutLevel,
        className: "flex flex-col gap-10 ".concat(className),
        id: id
    }, isCarrousel && !isMobileCarrousel && {
        overflows: true
    }), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-10 lg:flex-row lg:gap-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,es/* oneLine */.f9)(_templateObject(), isMobileCarrousel ? "lg:w-1/3 md:lg:w-2/3" : isCarrousel ? "lg:w-1/3" : "lg:w-2/3"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                            className: "justify-center ",
                            direction: "column",
                            textAlign: "start",
                            title: title,
                            desc: desc,
                            caption: caption,
                            variant: textColor
                        }),
                        (link === null || link === void 0 ? void 0 : link.uri) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: link.uri,
                            passHref: true,
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                className: "hidden lg:flex",
                                variant: link.variant,
                                underline: true,
                                arrow: true,
                                children: link.label
                            })
                        })
                    ]
                }),
                Array.isArray(blogProps) && !isCarrousel && /*#__PURE__*/ (0,jsx_runtime.jsx)(blog, (0,_object_spread/* default */.Z)({}, (blogProps === null || blogProps === void 0 ? void 0 : blogProps.at(0)) && {
                    cardAbove: blogProps[0]
                }, (blogProps === null || blogProps === void 0 ? void 0 : blogProps.at(1)) && {
                    cardBelow: blogProps[1]
                }, (blogProps === null || blogProps === void 0 ? void 0 : blogProps.at(2)) && {
                    cardLeft: blogProps[2]
                })),
                isCarrousel && !isMobileCarrousel && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-4 md:mx-0 lg:max-w-[66%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperCustom, {
                        scrollbar: true,
                        navigation: true,
                        slidesPerView: 3,
                        slidesPerViewMobile: 1.3,
                        gap: 24,
                        children: blogProps === null || blogProps === void 0 ? void 0 : blogProps.map(function(blog, index) {
                            return /*#__PURE__*/ (0,react.createElement)(card_blog/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, blog), {
                                key: index,
                                className: "h-full"
                            }));
                        })
                    })
                }),
                isMobileCarrousel && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:block",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(blog, (0,_object_spread/* default */.Z)({}, (blogProps === null || blogProps === void 0 ? void 0 : blogProps.at(0)) && {
                                    cardAbove: blogProps[0]
                                }, (blogProps === null || blogProps === void 0 ? void 0 : blogProps.at(1)) && {
                                    cardBelow: blogProps[1]
                                }, (blogProps === null || blogProps === void 0 ? void 0 : blogProps.at(2)) && {
                                    cardLeft: blogProps[2]
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-4 block md:mx-0 lg:hidden lg:max-w-[66%]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperCustom, {
                                scrollbar: true,
                                navigation: true,
                                slidesPerView: 3,
                                slidesPerViewMobile: 1.3,
                                gap: 24,
                                children: blogProps === null || blogProps === void 0 ? void 0 : blogProps.map(function(blog, index) {
                                    return /*#__PURE__*/ (0,react.createElement)(card_blog/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, blog), {
                                        key: index,
                                        className: "h-full"
                                    }));
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (link === null || link === void 0 ? void 0 : link.uri) && (link === null || link === void 0 ? void 0 : link.label) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        prefetch: false,
                        href: link.uri,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                            underline: true,
                            arrow: true,
                            className: "self-center lg:hidden",
                            href: link.uri,
                            variant: link.variant,
                            children: link.label
                        })
                    })
                })
            ]
        })
    }));
};
CardsBlogTemplate.displayName = "CardsBlogTemplate";

;// CONCATENATED MODULE: ./components/templates/cards-blog-template/index.ts

/* harmony default export */ var cards_blog_template = (CardsBlogTemplate);


/***/ })

}]);